import * as React from "react";
import { memo } from "react";
import { useSelector } from "react-redux";
import { useStaticContext } from "../../../../core";
import { E2EIdentifier } from "../../../../core/e2e/E2EIdentifier";
import { IState } from "../../../redux";
import {
  DisplayDesktopDefault,
  DisplayDesktopMinimal,
  IDisplayDesktopProps
} from "./Display";
import { MoneyType } from "../../../../api/api";

const wrapper = (
  TheGenericDisplay: React.FunctionComponent<IDisplayDesktopProps>
) => {
  const { language } = useStaticContext();
  const moneyType = useSelector((state: IState) => state.money.moneyType);
  const freeRoundsLeft = useSelector((state: IState) => state.freeRounds.value);

  const isCash = moneyType === MoneyType.CASH;

  const value = freeRoundsLeft?.toString() ?? "";

  const dataE2EId = E2EIdentifier.DESKTOP_KEYPAD_FREE_ROUNDS_LEFT;

  const props: IDisplayDesktopProps = {
    label: language.FreeRoundsLeft.toUpperCase(),
    value,
    isCash,
    dataE2EId
  };
  return <TheGenericDisplay {...props} />;
};

export const FreeRoundsDisplayDesktopDefault = memo(
  function FreeRoundsDisplayDesktopDefault() {
    return wrapper(DisplayDesktopDefault);
  }
);

export const FreeRoundsDisplayDesktopMinimal = memo(
  function FreeRoundsDisplayDesktopMinimal() {
    return wrapper(DisplayDesktopMinimal);
  }
);
